<template>
  <div class="body-container giveaway-list">
    <div class="head-search-box">
      <div class="time-box" @click="$refs.datePanel.open()">
        <span>{{ startTime.replace(/-/g, '/') }} - {{ endTime.replace(/-/g, '/') }}</span>
        <i class="arr-icon"></i>
      </div>
      <img @click="goSearch" src="@static/images/search2.png" class="search-icon" />
    </div>
    <van-pull-refresh v-model="isLoading" @refresh="onReferesh">
      <div class="list-wrap">
        <van-list v-model="listLoading" :finished="finished" :finished-text="finishedText" @load="nextPage">
          <div v-for="(item, index) in list" :key="index">
            <div v-if="$route.query.isPay == '0'" class="list">
              <div>
                <div class="main-title">
                  {{ item.productName }}
                </div>
                <div class="m-intro">
                  <span>创建时间：</span>
                  <b>{{ item.createTime }}</b>
                </div>
                <div class="m-intro">
                  <span>有效期至：</span>
                  <b>{{ item.expireTime }}</b>
                </div>
                <div v-if="item.nickname" class="m-intro">
                  <span>领取人：</span>
                  <b>{{ item.nickname }}</b>
                </div>
                <div
                  class="btn-send"
                  @click.stop="item.effectiveStatus == 1 && send(item)"
                  :class="{ 'disabled': item.effectiveStatus == 0 || item.salesStatus == 1 }"
                >
                  分享
                </div>
              </div>
            </div>
            <div v-else @click="goDetail(item)">
              <div class="hold-time">
                投保时间：{{ item.holdTime | transformTime | timeSub(16) }}
                <div
                  class="tag"
                  :class="{
                    'orange': [0, 2, -1].includes(item.policyStatus * 1),
                    'blue': [1].includes(item.policyStatus * 1)
                  }"
                >
                  <span>{{ policyStatus[item.policyStatus] }}</span>
                </div>
              </div>
              <div class="list">
                <div class="main-title">
                  {{ item.productName }}
                </div>
                <div class="m-intro">
                  <span>创建时间：</span>
                  <b>{{ item.createTime }}</b>
                </div>
                <div v-if="item.nickname" class="m-intro">
                  <span>领取人：</span>
                  <b>{{ item.nickname }}</b>
                </div>
                <div class="m-intro">
                  <span>投/被保险人：</span>
                  <b>{{ item.holderName }}/{{ item.insuranceName }}</b>
                </div>
                <div class="m-intro">
                  <span>保障期限：</span>
                  <b v-if="item.guarateeType == 1">{{ item.startTime | transformTime | timeSub(10) }}至终身</b>
                  <b v-else>{{ item.startTime | transformTime | timeSub(10) }} - {{ item.endTime | transformTime | timeSub(10) }}</b>
                </div>
              </div>
            </div>
          </div>
          <div class="null" v-if="list.length <= 0 && !listLoading">
            <img class="null-img" src="@static/images/null.png" />
            <span class="null-text">暂无内容</span>
          </div>
        </van-list>
      </div> </van-pull-refresh
    >
    <!-- 日期选择弹窗 -->
    <datePopup ref="datePanel" dateType="date" @submit="selectDate"></datePopup>
    <div class="yindao" v-if="showYindao" @click="showYindao = false"></div>
  </div>
</template>
    <script>
import dayjs from 'dayjs';
import { Dialog } from 'vant';
import { common, pageTools, share } from '@/api/mixins';
import datePopup from '@/components/tools/datePopup';
//当前实例组件
export default {
  components: { datePopup },
  mixins: [common, pageTools, share],
  data: () => ({
    userinfo: {},
    show: false,
    isLoading: true, //下拉刷新
    finished: true, //是否完成上拉加载
    totalInfo: {}, //业务员赠险产品统计
    showYindao: false, //分享引导图
    startTime: dayjs().startOf('month').format('YYYY-MM-DD'),
    endTime: dayjs().format('YYYY-MM-DD'),
    finishedText: '没有更多了',
    policyStatus: {
      '0': '已终止',
      '1': '已承保',
      '2': '已中止',
      '-1': '已退保'
    },
    searchParams: {
      //列表查询参数
      pageSize: 10,
      pageNo: 1,
      isPay: ''
    }
  }),
  mounted() {
    if (!this.checkLogin()) {
      return;
    }
    if (this.$route.query.isPay == '0') {
      this.$tools.setWebTitle('已赠送未投保');
    } else {
      this.$tools.setWebTitle('已投保');
    }
    this.$weixin.hideMenu();
    this.userinfo = this.getUser();
    this.initListAjax('/api/giveawayProduct/queryPayList');
  },
  methods: {
    goDetail(item) {
      if (item.detailUrl) {
        this.$app.openWeb(item.detailUrl, null, 'partner');
      } else {
        if (this.$config.isApp) {
          this.$app.openWeb(location.origin + `/apps/order/detail?orderNo=${item.orderNo}&policyNo=${item.policyNo}`);
        } else {
          this.goPage('/apps/order/detail', { orderNo: item.orderNo, policyNo: item.policyNo });
        }
      }
    },
    goSearch() {
      if (this.$config.isApp) {
        this.$app.openWeb(location.origin + `/apps/giveawayProduct/search?isPay=${this.$route.query.isPay}`);
      } else {
        this.$router.push({
          path: '/apps/giveawayProduct/search',
          query: {
            isPay: this.$route.query.isPay
          }
        });
      }
    },
    // 选择时间
    selectDate(date) {
      console.log('selectDate', date);
      this.startTime = date[0];
      this.endTime = date[1];
      this.onReferesh();
    },
    setListParams(params) {
      params.isPay = this.$route.query.isPay;
      params.createTimeStart = this.startTime;
      params.createTimeEnd = this.endTime;
    },
    //赠送
    send(item) {
      if (item.salesStatus == 1) {
        return this.$notice.msg('该产品已停售，不能赠送了噢');
      }
      if (item.effectiveStatus == 0) {
        return Dialog.alert({
          message: '尊敬的客户十分抱歉，由于您未在有效期内完成投保，该赠险链接已失效。',
          confirmButtonColor: '#FF8B00',
          confirmButtonText: '知道了'
        });
      }
      const shareData = {
        title: `送你一份【${item.productName}】`,
        link: location.origin + '/apps/jump.html?p=' + item.insureUrl,
        content: '快快领取吧~~', //分享的描述,
        logo: item.mobileCover,
        target: 'wx,copy_link'
      };
      if (this.$config.isApp) {
        this.openSharePanel(shareData, true);
      } else {
        this.copy(shareData.link);
      }
    },
    copy(text) {
      const cInput = document.createElement('input');
      cInput.value = text;
      document.body.appendChild(cInput);
      // 选取文本域内容;
      cInput.select();
      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('Copy');
      this.$notice.msg('投保链接复制成功');
      /// 复制成功后再将构造的标签 移除
      cInput.remove();
    },
    onReferesh() {
      this.isLoading = false;
      this.searchAjax();
    }
  }
};
</script>
<style lang="scss" scoped>
@import './orderList.scss';
</style>
    